import { useTimer } from 'react-timer-hook';

type PropsTimer = {
  startedTime?: Date;
  expiryTime: number;
  onExpireTime: () => void;
  variant?: 'default' | 'compact' | 'micro';
  className?: string;
  showLabel?: boolean;
};

export function Timer({
  startedTime = new Date(),
  expiryTime,
  onExpireTime,
  variant = 'default',
  className = '',
  showLabel = true,
}: PropsTimer) {
  const time = new Date(startedTime);
  const oneMinuteLeft = expiryTime - 1;
  time.setSeconds(time.getSeconds() + oneMinuteLeft * 60);

  const { seconds, minutes, hours } = useTimer({
    expiryTimestamp: time,
    onExpire: () => onExpireTime(),
  });
  const formattedTime = [hours, minutes, seconds]
    .map(value => String(value).padStart(2, '0'))
    .join(':');
  const isCompact = variant === 'compact';
  const isMicro = variant === 'micro';
  let containerClassName = 'flex items-end gap-3';
  let timeClassName =
    'text-4xl font-semibold tracking-[-0.04em] text-white sm:text-5xl';
  let labelClassName =
    'pb-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400';

  if (isCompact) {
    containerClassName = 'flex items-end gap-2';
    timeClassName =
      'text-lg font-semibold tracking-[-0.03em] text-slate-900 sm:text-xl';
    labelClassName =
      'pb-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500';
  } else if (isMicro) {
    containerClassName = 'flex items-end gap-1';
    timeClassName = 'text-base font-semibold tracking-[-0.02em] text-slate-900';
    labelClassName =
      'pb-0.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-slate-500';
  }

  return (
    <div
      aria-label={`Tempo restante ${hours} horas, ${minutes} minutos e ${seconds} segundos`}
      aria-live="polite"
      role="timer"
      className={`${containerClassName} ${className}`.trim()}
    >
      <p className={timeClassName}>{formattedTime}</p>
      {showLabel && <p className={labelClassName}>hh:mm:ss</p>}
    </div>
  );
}
